import {
  useEffect,
  useRef,
  useState,
} from "react";

export const usePipInteractions = () => {
  const pipRef = useRef<HTMLDivElement>(null);
  const dragHandleRef = useRef<HTMLDivElement>(null);
  const [ position, setPosition ] = useState({
    x: 0,
    y: 0,
  });

  useEffect(() => {
    const pip = pipRef.current;
    const handle = dragHandleRef.current;
    if (!pip || !handle) return;

    let offsetX = 0, offsetY = 0, dragging = false;

    const onMove = (e: MouseEvent | TouchEvent) => {
      if (!dragging) return;

      const clientX = "touches" in e ? e.touches[ 0 ]?.clientX : e.clientX;
      const clientY = "touches" in e ? e.touches[ 0 ]?.clientY : e.clientY;

      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;
      const pipWidth = pip.offsetWidth;
      const pipHeight = pip.offsetHeight;

      let newX = clientX! - offsetX;
      let newY = clientY! - offsetY;

      newX = Math.max(0, Math.min(newX, viewportWidth - pipWidth));
      newY = Math.max(0, Math.min(newY, viewportHeight - pipHeight));

      setPosition({
        x: newX,
        y: newY,
      });

      e.preventDefault?.();
    };


    const onEnd = () => {
      dragging = false;
      document.removeEventListener("mousemove", onMove);
      document.removeEventListener("mouseup", onEnd);
      document.removeEventListener("touchmove", onMove);
      document.removeEventListener("touchend", onEnd);
    };

    const onStart = (e: MouseEvent | TouchEvent) => {
      const clientX = "touches" in e ? e.touches[ 0 ]?.clientX : e.clientX;
      const clientY = "touches" in e ? e.touches[ 0 ]?.clientY : e.clientY;
      offsetX = clientX! - pip.offsetLeft;
      offsetY = clientY! - pip.offsetTop;
      dragging = true;

      document.addEventListener("mousemove", onMove);
      document.addEventListener("mouseup", onEnd);
      document.addEventListener(
        "touchmove", onMove, {
          passive: false,
        },
      );
      document.addEventListener("touchend", onEnd);
    };

    handle.addEventListener("mousedown", onStart);
    handle.addEventListener(
      "touchstart", onStart, {
        passive: false,
      },
    );

    return () => {
      handle.removeEventListener("mousedown", onStart);
      handle.removeEventListener("touchstart", onStart);
    };
  }, []);

  return {
    pipRef,
    dragHandleRef,
    position,
  };
};
